import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { BatonEnv, BatonStatus, retransmitBaton } from '@cimpress-technology/baton-client';
import { Alert, Button, Modal } from '@cimpress/react-components';
import { Spinner } from '@cimpress/react-components/lib/shapes';
import { getI18nInstance } from '../../locales/i18n';
import { concatenatePlatformSupportMsg } from '../../utils/helper';
export const ReTransmit = props => {
    const t = getI18nInstance().getFixedT(props.language);
    const [context, setContext] = useState({
        showReTransmissionContent: false,
        newBaton: undefined,
        retransmissionComplete: false,
        isLoading: false,
        error: undefined
    });
    const triggerReTransmitBaton = async () => {
        var _a, _b;
        setContext((previousContext => (Object.assign(Object.assign({}, previousContext), { isLoading: true }))));
        if (props.batonToTransmit) {
            try {
                const response = await retransmitBaton(props.accessToken, props.batonToTransmit.id, undefined, props.env === 'prd' ? BatonEnv.PRODUCTION : BatonEnv.INTEGRATION);
                if (response) {
                    setContext(prev => (Object.assign(Object.assign({}, prev), { newBaton: response, retransmissionComplete: true, isLoading: false })));
                }
            }
            catch (error) {
                const e = error;
                const errorMsg = (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
                setContext(prev => { var _a, _b; return (Object.assign(Object.assign({}, prev), { isLoading: false, retransmissionComplete: true, error: { title: ((_a = e.response) === null || _a === void 0 ? void 0 : _a.statusText) || 'Failed', details: `${errorMsg || error.toString()}${concatenatePlatformSupportMsg((_b = e.response) === null || _b === void 0 ? void 0 : _b.status)}` } })); });
            }
        }
    };
    const isReTransmitButtonDisabled = () => {
        var _a, _b;
        if ((_a = props.batonList) === null || _a === void 0 ? void 0 : _a.find(b => { var _a; return b.transmissionMethodKey === ((_a = props.batonToTransmit) === null || _a === void 0 ? void 0 : _a.transmissionMethodKey) && b.status === (BatonStatus.LOCKED) || (b.status === BatonStatus.OPEN); })) {
            return true;
        }
        if ((_b = props.batonToTransmit) === null || _b === void 0 ? void 0 : _b._links.retransmittedBaton) {
            return true;
        }
        return false;
    };
    const reTransmitBody = (context.isLoading
        ? _jsx(Spinner, {})
        : (_jsx("div", { children: !context.retransmissionComplete
                ? t('itemTransmission.reTransmit.reTransmissionConfirmation')
                : context.error
                    ? _jsx(Alert, { title: context.error.title, message: context.error.details, type: 'danger', dismissible: false })
                    : _jsx(Alert, { message: t('itemTransmission.reTransmit.reTransmissionSuccess'), type: 'success', dismissible: false }) })));
    const footerElement = (!context.isLoading
        ? _jsx(_Fragment, { children: context.retransmissionComplete ? _jsx(Button, Object.assign({ onClick: props.onClose }, { children: "Go Back" }))
                : _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: 'primary', size: 'sm', onClick: triggerReTransmitBaton }, { children: t('button.yes') })), _jsx(Button, Object.assign({ variant: 'default', size: 'sm', style: { marginLeft: '20px' }, onClick: () => setContext(prev => (Object.assign(Object.assign({}, prev), { showReTransmissionContent: false }))) }, { children: t('button.cancel') }))] }) })
        : null);
    return _jsxs("div", Object.assign({ style: { padding: '12px' } }, { children: [_jsx(Button, Object.assign({ size: 'sm', variant: 'primary', disabled: isReTransmitButtonDisabled(), onClick: () => setContext(Object.assign(Object.assign({}, context), { showReTransmissionContent: true })) }, { children: t('itemTransmission.tableHeader.reTransmit') })), _jsx(Modal, Object.assign({ title: t('itemTransmission.reTransmit.title'), status: 'warning', closeButton: true, show: context.showReTransmissionContent, closeOnOutsideClick: true, footer: footerElement }, { children: reTransmitBody }))] }));
};
